import { hasMinimumLength } from './resultsHelper';

const trimSizeToNearestCarriage = (value, maxChars, maxLines, suffix) => {
  const text = value.substring(0, maxChars);
  let lines = text.split(/\n/);

  if (lines.length > 1) { lines.pop(); }
  while (lines.length > 0 && !hasMinimumLength(lines[lines.length - 1])) { lines.pop(); }

  if (maxLines > 0 && lines.length > maxLines) {
    lines = lines.slice(0, maxLines);
  }
  if (suffix) { lines.push(suffix); }

  return lines.join('\n');
};

const trimSize = (value, maxChars, maxLines = 0, suffix = null) => {
  const chars = (value || '').length;
  const lines = (value || '').split(/\n/);
  const lineCount = lines.length;
  const charsAndText = { value, max: maxChars, trimmed: (chars > maxChars) || (maxLines > 0 && lineCount > maxLines) };

  if (charsAndText.trimmed) {
    charsAndText.value = trimSizeToNearestCarriage(value, maxChars, maxLines, suffix);
  }

  return charsAndText;
};

export default trimSize;
